<cm-infinite-list [count]="$totalCount()" [intersectionStatusChange]="$pageFilledStatusChange()" class="cm-items-list">
    <cm-list-info cm-list-header [parentList]="this" [count]="$totalCount()"></cm-list-info>
    @for (item of $items(); track item.trackId) {
        @if (item.data; as hdri) {
            <cm-entity-card @fadeInCard [entity]="hdri" [entityLink]="[hdri.id]"></cm-entity-card>
        } @else if (item.placeholder) {
            <cm-card-placeholder @fadeInPlaceholder></cm-card-placeholder>
        } @else if (item.error) {
            <cm-card-error @fadeInPlaceholder></cm-card-error>
        }
    }
</cm-infinite-list>
